import React, { useContext } from 'react'
import CustTable from '../../Common/CustTable'
import { t } from 'i18next'
import { Button, Flex } from 'antd'
import { FormOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import GlobalContext from '../GlobalContext'
import { ConsultationStateTag, SlotStateTag } from '../TagsPage/StateTag'
import SlotTypeTag from '../TagsPage/SlotTypeTag'

export default function SlotHistoryList ({ slots, loading, collapsed }) {
  const screens = useBreakpoint()
  const { boxes } = useContext(GlobalContext)

  const columns = (screens, boxes) => [
    {
      width: 100,
      title: t('Admin.SlotList.table.date'),
      dataIndex: 'begin_date',
      key: 'begin_date',
      render: (_, o) => dayjs(o.begin_date).format('dddd DD MMMM'),
      sorter: (a, b) => dayjs(a.begin_date) - dayjs(b.begin_date),
      showSorterTooltip: false
    },
    {
      width: 100,
      title: t('Admin.SlotList.table.range'),
      dataIndex: 'range',
      key: 'range',
      render: (_, o) => `${dayjs(o.begin_date).format('H[h]mm')}-${dayjs(o.end_date).format('H[h]mm')}`,
      sorter: (a, b) => dayjs(a.begin_date) - dayjs(b.begin_date),
      showSorterTooltip: false
    },
    {
      width: 80,
      title: t('Admin.SlotList.table.slotType'),
      dataIndex: 'type',
      key: 'type',
      render: (_, o) => <SlotTypeTag type={o.type} />,
      sorter: (a, b) => a?.type.localeCompare(b?.type),
      showSorterTooltip: false,
      hidden: !screens.md
    },
    {
      title: t('Admin.SlotList.table.name'),
      dataIndex: 'name',
      key: 'name',
      width: 200,
      sorter: (a, b) => a.name.localeCompare(b.name),
      showSorterTooltip: false
    },
    {
      title: t('Admin.SlotList.table.age'),
      dataIndex: 'age',
      key: 'age',
      width: 60
    },
    {
      title: t('Admin.SlotList.table.bookedSlots'),
      dataIndex: 'booked_slots',
      key: 'booked_slots',
      width: 80,
      render: (_, o) => o.booked_slots
    },
    {
      title: t('Admin.SlotList.table.box'),
      dataIndex: 'box.name',
      key: 'box.name',
      render: (_, o) => {
        const box = boxes.find(box => box.id === o.box_id)
        return box.name
      },
      width: 200,
      sorter: (a, b) => {
        const boxA = boxes.find(box => box.id === a.box_id)
        const boxB = boxes.find(box => box.id === b.box_id)
        return boxA.name.localeCompare(boxB.name)
      },
      showSorterTooltip: false
    },
    {
      title: t('Admin.SlotList.table.assigned'),
      dataIndex: 'assigned_short_name',
      key: 'assigned_short_name',
      width: 100,
      sorter: (a, b) => a.assigned_short_name.localeCompare(b.assigned_short_name),
      showSorterTooltip: false,
      render: (_, o) => o.assigned_short_name
    },
    {
      width: 100,
      title: t('Admin.SlotList.table.phone'),
      dataIndex: 'phone',
      key: 'phone',
      render: (phone) => `+${phone}`,
      sorter: (a, b) => a.phone - b.phone,
      showSorterTooltip: false
    },
    {
      width: 160,
      title: t('Admin.SlotList.table.state'),
      dataIndex: 'state',
      key: 'state',
      render: (_, o) => <Flex>
        <SlotStateTag slot={o} />
        <ConsultationStateTag slot={o} />
      </Flex>,
      sorter: (a, b) => a?.state.localeCompare(b?.state),
      showSorterTooltip: false
    },
    {
      width: 80,
      key: 'action',
      render: (_, o) => <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <Link to={`/admin/slots/${o.id}?from=list`}><Button shape="circle" icon={<FormOutlined />} /></Link>
      </div>
    }
  ].filter((col) => !col.hidden)

  return (
    <CustTable
      height={collapsed ? 700 : 550}
      initColumns={columns(screens, boxes)}
      dataSource={slots}
      loading={loading}
      style={{ marginTop: '1em' }}
    />
  )
}
